import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.new.spacing.small,
    margin: 0,
    cursor: 'pointer',

    '& .MuiSwitch-root': {
      width: 36,
      height: 20,
      padding: 0,
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: theme.new.color.common.white,
        '& + .MuiSwitch-track': {
          backgroundColor: theme.new.color.brandPrimary,
          opacity: 1,
        },
      },
      '&:not(.Mui-checked)': {
        color: theme.new.color.common.white,
        '& + .MuiSwitch-track': {
          backgroundColor: theme.new.color.grey[300],
          opacity: 1,
        },
      },
      '&.Mui-disabled': {
        color: theme.new.color.grey[300],
        '& + .MuiSwitch-track': {
          backgroundColor: theme.new.color.grey[300],
          opacity: 0.5,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 16,
      height: 16,
      boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
      borderRadius: theme.new.shape.borderRadius.medium,
      opacity: 1,
    },
  },
  label: {
    color: theme.new.color.textPrimary,
  },
}));

export default useStyles;
